const testimonials = [
  {
    name: 'Marcus Chen',
    role: 'Sneaker Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20man%20with%20stylish%20black%20bomber%20jacket%20and%20confident%20smirk%20against%20dark%20moody%20studio%20background%2C%20dramatic%20side%20lighting%2C%20urban%20street%20style%20editorial%20portrait%20photography%20with%20gritty%20texture&width=120&height=120&seq=testimonial-v2-01&orientation=squarish',
    text: 'This superbuy spreadsheet saved me so much time. I found trusted sneaker sellers I would have never discovered on my own. The category organization is incredibly intuitive and easy to navigate.',
    rating: 5,
  },
  {
    name: 'Sophie Laurent',
    role: 'Fashion Blogger',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20young%20woman%20with%20wavy%20auburn%20hair%20and%20cream%20silk%20top%20against%20soft%20lavender%20studio%20background%2C%20warm%20golden%20hour%20lighting%2C%20sophisticated%20lifestyle%20portrait%20photography%20with%20dreamy%20bokeh%20effect&width=120&height=120&seq=testimonial-v2-02&orientation=squarish',
    text: 'As someone who writes about streetwear, the best superbuy spreadsheet I have ever used. The designer category alone is worth it. Updated regularly and the quality checks are thorough.',
    rating: 5,
  },
  {
    name: 'David Park',
    role: 'Streetwear Enthusiast',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20man%20with%20trendy%20oversized%20graphic%20hoodie%20and%20relaxed%20pose%20against%20urban%20brick%20wall%20background%2C%20cool%20natural%20daylight%2C%20authentic%20street%20style%20portrait%20photography%20with%20candid%20feel&width=120&height=120&seq=testimonial-v2-03&orientation=squarish',
    text: 'Been using superbuy spreadsheets for years and this is by far the most comprehensive one. The hoodies and jackets sections are particularly well-researched with great seller recommendations.',
    rating: 5,
  },
  {
    name: 'Emma Nilsson',
    role: 'Online Shopper',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Scandinavian%20woman%20with%20platinum%20blonde%20hair%20and%20minimalist%20beige%20knit%20sweater%20against%20pale%20mint%20studio%20background%2C%20soft%20diffused%20daylight%2C%20fresh%20clean%20portrait%20photography%20with%20natural%20glow&width=120&height=120&seq=testimonial-v2-04&orientation=squarish',
    text: 'I was new to Superbuy and completely lost until I found this spreadsheet. The safety guide and trusted seller lists made my first purchase smooth and worry-free. Highly recommend to beginners.',
    rating: 5,
  },
  {
    name: "James O'Brien",
    role: 'Reseller',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20mature%20man%20in%20forties%20with%20tailored%20navy%20suit%20and%20confident%20expression%20against%20warm%20amber%20studio%20background%2C%20professional%20corporate%20lighting%2C%20executive%20portrait%20photography%20with%20authority%20and%20warmth&width=120&height=120&seq=testimonial-v2-05&orientation=squarish',
    text: 'The superbuy spreadsheet 2026 edition helped me scale my reselling business. I can now source quality items efficiently across multiple categories without wasting time on unreliable sellers.',
    rating: 5,
  },
  {
    name: 'Yuki Tanaka',
    role: 'Designer Collector',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20stylish%20young%20Asian%20woman%20with%20trendy%20oversized%20sunglasses%20pushed%20up%20on%20her%20head%20and%20chic%20black%20turtleneck%20against%20coral%20pink%20studio%20background%2C%20fashion%20forward%20editorial%20portrait%20photography%20with%20vibrant%20energy&width=120&height=120&seq=testimonial-v2-06&orientation=squarish',
    text: 'Finally a superbuy fashion spreadsheet that actually delivers. The luxury brands section is my go-to resource. Every seller I have contacted through this spreadsheet has been reliable and professional.',
    rating: 5,
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Community Reviews</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Trusted by Thousands Worldwide
          </h2>
          <p className="text-foreground-600 text-base md:text-lg font-light max-w-2xl mx-auto">
            Real feedback from real shoppers who use our superbuy spreadsheet every day
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/50 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed flex-1 mb-6">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}